import { connect } from 'react-redux'

import DeviceSummary from './DeviceSummary'

const mapStateToProps = (state) => ({
  device: state.native.nativeAppInfo.device,
})

export default connect(mapStateToProps, undefined)(DeviceSummary)
